import { AttributeFacet, FacetBase, ListFacetBase, TreeFacet } from '@mp/shared/facets/domain';

export function isSelected(bucket: FacetBase.BucketBase): boolean {
  return bucket.selected;
}

export function getSelectedBuckets(facet: ListFacetBase): ListFacetBase.Bucket[] {
  return facet.buckets.filter(isSelected).map((bucket: ListFacetBase.Bucket) => bucket);
}

export function getSelectedValues(facet: ListFacetBase): string[] {
  return facet.buckets.filter(isSelected).map((bucket: ListFacetBase.Bucket) => bucket.value);
}

export function getSelectedNodeValue(facet: TreeFacet): string | undefined {
  return _getSelectedLeaf(facet.root)?.value;
}

export function getSelectedNode(facet: TreeFacet): TreeFacet.Bucket | undefined {
  return _getSelectedLeaf(facet.root);
}

function _getSelectedLeaf(node: TreeFacet.Bucket): TreeFacet.Bucket | undefined {
  if (!isSelected(node)) {
    return undefined;
  }

  for (const childCategory of node.children || []) {
    const selectedLeaf = _getSelectedLeaf(childCategory);
    if (selectedLeaf) {
      return selectedLeaf;
    }
  }

  return node;
}

export function getSelectedParentAttributes(facet: AttributeFacet): AttributeFacet.BucketLevel0[] {
  return facet.buckets.filter(isSelected);
}

export function getSelectedChildrenAttributes(node: AttributeFacet.BucketLevel0): AttributeFacet.BucketLevel1[] {
  return node.selected ? node.children.filter(isSelected).map((bucket: AttributeFacet.BucketLevel1) => bucket) : [];
}

export function getSelectedAttributeValues(facet: AttributeFacet): string[] {
  return facet.buckets
    .filter(isSelected)
    .flatMap((bucket: AttributeFacet.BucketLevel0) => _getSelectedChildrenAttributeValues(bucket));
}

function _getSelectedChildrenAttributeValues(node: AttributeFacet.BucketLevel0): string[] {
  return node.children.filter(isSelected).map((bucket: AttributeFacet.BucketLevel1) => bucket.value);
}
